import React from 'react'
import HomeBanner from '../components/home/HomeBanner'
import MultiTourList from '../components/Tours/MultiTourList'
import ToursShortList from '../components/Tours/ToursShortList'
import QuotationBlock from '../components/home/QuotationBlock'
import SubFooter from '../components/Footer/SubFooter'
import CitiesBlock from '../components/home/CitiesBlock'
import PulsaticTripAdvisor from '../components/Tours/PulsaticTripAdvisor'


function HomeScreen() {
  return (
    <div className="standard-ountline">
      <HomeBanner />
      <MultiTourList />
      <ToursShortList />
      <QuotationBlock />
      <CitiesBlock />
      <PulsaticTripAdvisor />
      <SubFooter />    
    </div>
  )
}

export default HomeScreen